import { useEffect, useRef } from 'react';
import { isEmbeddedInSucceed } from '../utils/cp-context';

const NEON_VERSION = '3.1.0';
const NEON_CDN_URL = `https://assets.powerschool.com/neon/${NEON_VERSION}`;
const NEON_UNVERSIONED_CDN_URL = 'https://assets.powerschool.com/neon/unversioned';

/**
 * This hook loads Neon's styles and fonts from the CDN when not embedded in Succeed.
 * Component scripts are not preloaded; Neon loads them on demand when each component is first used.
 */
export const usePreloadNeon = () => {
  const effectHasRunRef = useRef(false);
  useEffect(() => {
    if (isEmbeddedInSucceed()) {
      return; // Neon handled by applyNeonStylesToShadowDom in embedded mode
    }
    if (effectHasRunRef.current) {
      return;
    }

    const documentFragment = document.createDocumentFragment();

    // Load Neon CSS (required for design tokens)
    const styleLink = document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.href = `${NEON_CDN_URL}/css/neon-styles.css`;
    styleLink.id = 'neon-styles';
    documentFragment.appendChild(styleLink);

    // Load Neon fonts
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = `${NEON_UNVERSIONED_CDN_URL}/fonts.css`;
    fontLink.id = 'neon-fonts';
    documentFragment.appendChild(fontLink);

    document.head.appendChild(documentFragment);
    // eslint-disable-next-line no-console
    console.log('Neon styles loaded from:', `${NEON_CDN_URL}/css/neon-styles.css`);

    effectHasRunRef.current = true;
  }, []);
};
